import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function PrivacyPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background">
      <div className="max-w-2xl mx-auto px-6 py-16">
        <button
          onClick={() => navigate(-1)}
          className="flex items-center gap-2 text-sm text-muted-foreground hover:text-foreground mb-8"
        >
          <ArrowLeft className="h-4 w-4" />
          Back
        </button>

        <h1 className="font-heading text-3xl font-semibold text-foreground mb-8">
          Privacy Policy
        </h1>

        <div className="space-y-6 text-muted-foreground">
          <p>
            Your privacy matters to us. Here's how we handle your data:
          </p>

          <div className="space-y-4">
            <div>
              <h3 className="text-foreground font-medium mb-2">Data Collection</h3>
              <p className="text-sm">
                We collect basic data such as email and usage information to provide 
                and improve our service.
              </p>
            </div>

            <div>
              <h3 className="text-foreground font-medium mb-2">Data Usage</h3>
              <p className="text-sm">
                Your data is used only to improve your experience and deliver the service. 
                We do NOT sell user data to third parties.
              </p>
            </div>

            <div>
              <h3 className="text-foreground font-medium mb-2">Third-Party Services</h3>
              <p className="text-sm">
                We use secure third-party services (authentication, payments) that have 
                their own privacy policies.
              </p>
            </div>

            <div>
              <h3 className="text-foreground font-medium mb-2">Data Deletion</h3>
              <p className="text-sm">
                Users can request deletion of their data anytime by contacting us at{" "}
                <a href="mailto:decisora.help@gmail.com" className="text-primary hover:underline">
                  decisora.help@gmail.com
                </a>
              </p>
            </div>
          </div>

          <p className="text-xs text-muted-foreground/70 pt-4">
            Last updated: February 2026
          </p>
        </div>
      </div>
    </div>
  );
}
